import { RefObject } from 'react';
import { FC } from 'react';
import styles from './ScrollAnchor.module.scss';

interface Props {
  anchorRef: RefObject<HTMLDivElement>;
}

export const ScrollAnchor: FC<Props> = ({ anchorRef }) => {
  return <div className={styles.anchor} ref={anchorRef} />;
};
